/* eslint-disable import/no-anonymous-default-export */
export default {
    EMAIL_JS_KEY: "user_mHHQUR9ZbZqQDutPcV71f",
    CAPTCHA_SITE_KEY: "6Lf51t4cAAAAAKRbGecPTBY6MdoZqD0uOv36TDCa",
    CAPTCHA_SECRET_KEY: "6Lf51t4cAAAAAGnXDvW2Ieb5rR-D2Ze3zvOb6RXU",
};